/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2025, Zumper
 */

import { isCypress } from './isCypress'

export function addServerSelectParam(url: URL) {
  if (
    typeof window !== 'undefined' &&
    url.origin !== window.location.origin &&
    typeof document.cookie === 'string'
  ) {
    const serverSelect =
      document.cookie
        .split(';')
        .find((cookie) =>
          cookie
            .trim()
            .startsWith(
              `serverSelect_web${
                window.location.hostname
                  .toLowerCase()
                  .match(/\.([a-z]+)\.com/)?.[1]
              }=`
            )
        ) ||
      // @ts-expect-error __GIT_SHA__ doesn't exist
      (isCypress() && window.__GIT_SHA__)
    if (serverSelect) {
      url.searchParams.set(
        `serverSelect_web${
          url.hostname.toLowerCase().match(/\.([a-z]+)\.com/)?.[1]
        }`,
        serverSelect.substring(serverSelect.indexOf('=') + 1)
      )
    }
  }
}
